/**
 * @generated SignedSource<<c5b180fe38b4c08feb6f3b0b5757b1be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PresentationPresenterPhotoNew_presentation$data = {
  readonly guestPresenterAvatarUrl: string;
  readonly presenter: {
    readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  } | null | undefined;
  readonly " $fragmentType": "PresentationPresenterPhotoNew_presentation";
};
export type PresentationPresenterPhotoNew_presentation$key = {
  readonly " $data"?: PresentationPresenterPhotoNew_presentation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationPresenterPhotoNew_presentation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "dpr",
  "variableName": "dpr"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "dpr"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationPresenterPhotoNew_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "presenter",
      "plural": false,
      "selections": [
        {
          "args": [
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "imageSize",
              "variableName": "imageSize"
            }
          ],
          "kind": "FragmentSpread",
          "name": "UserPrimaryPhotoNew_user"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "h",
              "variableName": "imageSize"
            },
            {
              "kind": "Variable",
              "name": "w",
              "variableName": "imageSize"
            }
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "guestPresenterAvatarUrl",
      "storageKey": null
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};
})();

(node as any).hash = "0c85c5e9ab9be60193a4249d3f97931c";

export default node;
